(function() {
  // Inject CSS styles for the Toast UI and Cart Icon animations
  const styles = `
    #custom-cart-toast-container {
      position: fixed;
      top: 20px;
      z-index: 100000;
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 380px;
      max-width: calc(100vw - 40px);
      pointer-events: none;
      font-family: inherit;
      direction: rtl; /* Hebrew RTL support */
    }
    
    html[dir="rtl"] #custom-cart-toast-container {
      left: 20px;
    }
    
    html[dir="ltr"] #custom-cart-toast-container {
      right: 20px;
    }
    
    @media (max-width: 767px) {
      #custom-cart-toast-container {
        top: auto;
        bottom: 24px;
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%);
        width: calc(100vw - 32px);
        gap: 8px;
      }
    }
    
    .custom-cart-toast {
      background: var(--color-background, #ffffff);
      color: var(--color-foreground, #2b2b2a);
      border: 1px solid var(--color-border, #e0e0e0);
      border-radius: var(--style-border-radius-popover, 8px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      pointer-events: auto;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      animation: custom-toast-slide-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
      transition: all 0.3s ease;
      opacity: 0;
    }
    
    .custom-cart-toast.fade-out {
      animation: custom-toast-fade-out 0.3s ease forwards;
    }
    
    @keyframes custom-toast-slide-in {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes custom-toast-fade-out {
      from {
        opacity: 1;
        transform: scale(1);
      }
      to {
        opacity: 0;
        transform: scale(0.95);
      }
    }
    
    @media (max-width: 767px) {
      @keyframes custom-toast-slide-in {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    }
    
    .custom-cart-toast__body {
      display: flex;
      padding: 16px;
      gap: 14px;
      align-items: flex-start;
      position: relative;
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    }
    
    .custom-cart-toast__image-container {
      width: 64px;
      height: 64px;
      flex-shrink: 0;
      border-radius: var(--style-border-radius-inputs, 4px);
      overflow: hidden;
      border: 1px solid rgba(0, 0, 0, 0.06);
      background: #f9f9f9;
    }
    
    .custom-cart-toast__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .custom-cart-toast__info {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;
      text-align: right;
    }
    
    .custom-cart-toast__status-row {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #E5A93B; /* Theme gold accent */
      font-size: 0.85rem;
      font-weight: 700;
    }
    
    .custom-cart-toast__success-icon {
      width: 14px;
      height: 14px;
      stroke: currentColor;
      stroke-width: 2.5;
      fill: none;
    }
    
    .custom-cart-toast__title {
      margin: 2px 0 0 0;
      font-size: 0.95rem;
      font-weight: 700;
      line-height: 1.35;
      color: var(--color-foreground, #2b2b2a);
    }
    
    .custom-cart-toast__variant {
      font-size: 0.8rem;
      color: rgba(0, 0, 0, 0.5);
    }
    
    .custom-cart-toast__qty {
      font-size: 0.8rem;
      color: rgba(0, 0, 0, 0.6);
      margin-top: 2px;
    }
    
    .custom-cart-toast__close {
      position: absolute;
      top: 12px;
      left: 12px; /* RTL close button on top-left */
      background: none;
      border: none;
      padding: 4px;
      cursor: pointer;
      color: rgba(0, 0, 0, 0.3);
      transition: color 0.2s ease, transform 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }
    
    html[dir="ltr"] .custom-cart-toast__close {
      left: auto;
      right: 12px;
    }
    
    .custom-cart-toast__close:hover {
      color: var(--color-foreground, #2b2b2a);
      background: rgba(0, 0, 0, 0.05);
      transform: rotate(90deg);
    }
    
    .custom-cart-toast__close svg {
      width: 16px;
      height: 16px;
    }
    
    .custom-cart-toast__actions {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      padding: 12px 16px;
      background: rgba(0, 0, 0, 0.01);
    }
    
    .custom-cart-toast__btn {
      border: none;
      padding: 10px 16px;
      font-size: 0.85rem;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.2s ease;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-family: inherit;
    }
    
    .custom-cart-toast__btn--view-cart {
      background-color: #E5A93B; /* Brand gold */
      color: #ffffff;
      border-radius: var(--style-border-radius-buttons-primary, 4px);
    }
    
    .custom-cart-toast__btn--view-cart:hover {
      background-color: #d4982a;
      transform: translateY(-1px);
    }
    
    .custom-cart-toast__btn--continue {
      background-color: transparent;
      color: var(--color-foreground, #2b2b2a);
      border: 1px solid var(--color-border, #2b2b2a);
      border-radius: var(--style-border-radius-buttons-secondary, 4px);
    }
    
    .custom-cart-toast__btn--continue:hover {
      background-color: rgba(0, 0, 0, 0.03);
      transform: translateY(-1px);
    }
    
    /* Cart icon bounce animation */
    .cart-icon--bounce {
      animation: cart-icon-shake-bounce 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
      transform-origin: center bottom;
      display: inline-block !important;
    }
    
    @keyframes cart-icon-shake-bounce {
      0% { transform: scale(1); }
      15% { transform: scale(1.3) rotate(-10deg); }
      30% { transform: scale(1.3) rotate(10deg); }
      45% { transform: scale(1.2) rotate(-8deg); }
      60% { transform: scale(1.2) rotate(8deg); }
      75% { transform: scale(1.1) rotate(-4deg); }
      90% { transform: scale(1.05) rotate(2deg); }
      100% { transform: scale(1) rotate(0); }
    }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = styles;
  document.head.appendChild(styleEl);

  // Helper function to animate the header cart icon
  function animateCartIcon() {
    // Look for various cart icon selectors to ensure we target the right element
    const selectors = [
      'cart-icon',
      '.header-actions__cart-icon',
      '[data-testid="cart-drawer-trigger"]',
      '.header__icon--cart'
    ];
    
    let cartIcon = null;
    for (const selector of selectors) {
      cartIcon = document.querySelector(selector);
      if (cartIcon) break;
    }
    
    if (cartIcon) {
      cartIcon.classList.remove('cart-icon--bounce');
      // Force reflow
      void cartIcon.offsetWidth;
      cartIcon.classList.add('cart-icon--bounce');
      
      setTimeout(() => {
        cartIcon.classList.remove('cart-icon--bounce');
      }, 600);
    }
  }

  // Helper function to sync cart count and bubble visibility
  let syncTimeout = null;
  function syncCartCount() {
    if (syncTimeout) clearTimeout(syncTimeout);
    syncTimeout = setTimeout(async () => {
      try {
        const res = await originalFetch('/cart.js');
        const cart = await res.json();
        const count = cart.item_count;
        
        // 1. Update DOM cart count text content in standard themes
        const countTexts = document.querySelectorAll('#cart-bubble-text, .cart-bubble__text-count, [data-testid="cart-bubble"]');
        countTexts.forEach(el => {
          // If the element has children (like visually-hidden ones), only target the direct text child or count child
          const targetEl = el.querySelector('.cart-bubble__text-count') || el;
          targetEl.textContent = count;
          targetEl.classList.toggle('hidden', count === 0);
        });

        // 2. Update cart bubbles visibility
        const bubbles = document.querySelectorAll('.cart-bubble');
        bubbles.forEach(el => {
          el.classList.toggle('visually-hidden', count === 0);
          el.classList.toggle('hidden', count === 0);
        });
        
        // 3. Dispatch global theme event to keep all sections hydrated and updated
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'custom-cart-toast',
            data: {
              itemCount: count,
              source: 'custom-cart-toast-sync'
            }
          }
        }));
      } catch (e) {
        console.error('[CartToast] Error syncing cart count:', e);
      }
    }, 150);
  }

  // Render visual Toast Notification
  function showCartToast(item) {
    let container = document.getElementById('custom-cart-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'custom-cart-toast-container';
      document.body.appendChild(container);
    }

    // Determine product thumbnail image
    let imageUrl = item.image || '';
    if (!imageUrl && item.featured_image) {
      imageUrl = typeof item.featured_image === 'string' ? item.featured_image : (item.featured_image.url || '');
    }
    if (!imageUrl) {
      imageUrl = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="%23ccc" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>';
    }

    // Create toast component
    const toast = document.createElement('div');
    toast.className = 'custom-cart-toast';
    
    toast.innerHTML = `
      <div class="custom-cart-toast__body">
        <div class="custom-cart-toast__image-container">
          <img class="custom-cart-toast__image" src="${imageUrl}" alt="${item.product_title || item.title || 'מוצר'}">
        </div>
        <div class="custom-cart-toast__info">
          <div class="custom-cart-toast__status-row">
            <svg class="custom-cart-toast__success-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>הפריט נוסף לסל בהצלחה!</span>
          </div>
          <h4 class="custom-cart-toast__title">${item.product_title || item.title || 'מוצר'}</h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="custom-cart-toast__variant">${item.variant_title}</span>` : ''}
          <span class="custom-cart-toast__qty">כמות: ${item.quantity || 1}</span>
        </div>
        <button class="custom-cart-toast__close" aria-label="סגור">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="custom-cart-toast__actions">
        <button class="custom-cart-toast__btn custom-cart-toast__btn--view-cart">למעבר לעגלה</button>
        <button class="custom-cart-toast__btn custom-cart-toast__btn--continue">המשך בקניות</button>
      </div>
    `;

    // Append to container
    container.appendChild(toast);

    // Fade out and remove function
    const dismissToast = () => {
      if (toast.classList.contains('fade-out')) return;
      toast.classList.add('fade-out');
      toast.addEventListener('animationend', () => {
        toast.remove();
        if (container.children.length === 0) {
          container.remove();
        }
      });
    };

    // Close button click
    toast.querySelector('.custom-cart-toast__close').addEventListener('click', (e) => {
      e.stopPropagation();
      dismissToast();
    });

    // Continue button click
    toast.querySelector('.custom-cart-toast__btn--continue').addEventListener('click', (e) => {
      e.stopPropagation();
      dismissToast();
    });

    // Go to Cart click - open the cart drawer!
    toast.querySelector('.custom-cart-toast__btn--view-cart').addEventListener('click', (e) => {
      e.stopPropagation();
      dismissToast();
      
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]') || 
                        document.querySelector('.header-actions__cart-icon');
        if (trigger) trigger.click();
      }
    });

    // Auto-dismiss after 4.5 seconds
    setTimeout(dismissToast, 4500);
  }

  // Intercept window.fetch requests to catch cart additions globally
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = args[0];
    const response = await originalFetch.apply(this, args);
    
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
      if (response.ok) {
        try {
          const clone = response.clone();
          const data = await clone.json();
          
          // Support both single item and items array responses
          const addedItem = data.items && data.items.length ? data.items[0] : data;
          
          // Trigger the visual Toast and Bounce feedback!
          showCartToast(addedItem);
          animateCartIcon();
          syncCartCount();
        } catch (e) {
          console.error('[CartToast] Error parsing add response:', e);
        }
      }
    }
    
    return response;
  };
})();
